if (!customElements.get('infinite-products')) {
class InfiniteProducts extends HTMLElement {
  connectedCallback() {
    this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
    this.link = this.querySelector('[data-load-more]');
    this.status = this.querySelector('[role="status"]');
    if (!this.grid || !this.link) return;
    this.context = location.pathname + location.search;
    this.onClick = (event) => {
      event.preventDefault();
      this.load(true);
    };
    this.link.addEventListener('click', this.onClick);
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) this.load();
    }, { rootMargin: '0px 0px 1200px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
    this.link?.removeEventListener('click', this.onClick);
  }

  async load(manual = false) {
    if (this.loading || !this.dataset.nextUrl || !this.isConnected ||
        this.context !== location.pathname + location.search || !this.grid.getClientRects().length) return;
    this.loading = true;
    this.observer.unobserve(this);
    this.controller = new AbortController();
    const timeout = setTimeout(() => this.controller.abort(), 15000);
    this.grid.setAttribute('aria-busy', 'true');
    this.link.setAttribute('aria-disabled', 'true');
    this.status.textContent = this.dataset.loadingText;
    try {
      const url = new URL(this.dataset.nextUrl, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Invalid next page');
      url.searchParams.set('section_id', this.grid.dataset.id);
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!this.isConnected || this.context !== location.pathname + location.search) return;
      const nextGrid = html.getElementById('product-grid');
      const pagination = html.querySelector('infinite-products');
      if (!nextGrid || !pagination || Number(pagination.dataset.page) !== Number(this.dataset.page) + 1) {
        throw new Error('Invalid product page');
      }
      const items = [...nextGrid.children].filter(item => !item.matches('.collection__sticky-header, .collection__empty-collection, infinite-products'));
      const firstLink = items.find(item => item.querySelector('a.card'))?.querySelector('a.card');
      const fragment = document.createDocumentFragment();
      items.forEach(item => fragment.appendChild(item));
      this.grid.insertBefore(fragment, this.parentElement === this.grid ? this : null);
      this.dataset.page = pagination.dataset.page;
      this.dataset.nextUrl = pagination.dataset.nextUrl;
      this.link.hidden = !this.dataset.nextUrl;
      this.link.href = this.dataset.nextUrl || '#';
      this.status.textContent = this.dataset.nextUrl ? '' : this.dataset.completeText;
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(this.grid);
      if (manual) firstLink?.focus({ preventScroll: true });
      if (this.dataset.nextUrl) this.observer.observe(this);
    } catch (error) {
      if (this.isConnected && this.context === location.pathname + location.search) {
        this.status.textContent = this.dataset.errorText;
      }
    } finally {
      clearTimeout(timeout);
      this.loading = false;
      this.grid.removeAttribute('aria-busy');
      this.link.removeAttribute('aria-disabled');
    }
  }
}

customElements.define('infinite-products', InfiniteProducts);
}
